/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useRef, useState } from 'react';
import postal from 'postal';
import CustomerListSkyBlue from "../img/customer-list-dark.svg";
import CustomerListNotSelectedIcon from "../img/customer-list-light.svg";
import DashboardMenu from '../ui/dashboard/menu/DashboardMenu';
import ifmsLogo from '../img/ifms-logo-black.png';
import ifmsLogoWhite from '../img/ifms-logo_White.svg';
import orchidLogo from '../img/ochidLogo.png';
import orchidLogoDark from '../img/ochidLogo_D.png';
import { IfmsConfigMenuItem, IfmsConfigOperationMenu } from '../config/types';
import { SystemSettings, User } from '../ifmsTypes';
import { getSecBySecTask, MenuFilterGrents } from '../util';
import constants from '../constants';
import ReferenceFilesNotSelectedIcon from '../img/reference-files-light.svg';
import ReferenceFilesNotSelectedIconSkyBlue from '../img/reference-files-dark.svg';
import SettingsNotSelectedIcon from '../img/settings-light.svg';
import SettingsNotSelectedIconSkyBlue from '../img/settings-dark.svg';
import ContainerTrackingIcon from "../img/container_tracking.svg";
import ContainerTrackIconSkyBlue from "../img/container_tracking-skyblue.svg";
import inbondMenuIconBlue from "../img/in-bond-light.svg";
import inbondMenuIconSkyBlue from "../img/in-bond-dark.svg";
import UserButton, { UserButtonItem } from '../ui/UserButton';
import ApplicationContext from '../ApplicationContext';
import { FmsSecTask } from '../fms.core/constants';
import supportIcon from '../img/esupport-light.svg';
import supportIconSkyBlue from '../img/esupport-dark.svg';
import { changeOperation } from '../features/operationSlice';
import { useAppDispatch } from '../app/hooks';
import config from '../config';
import AccountingNotSelected from '../img/accounting-light.svg';
import WarehousingNotSelected from '../img/warehouse-light.svg';
import OceanImportNotSelected from '../img/ocean-import-light.svg';
import OceanExportNotSelected from '../img/ocean-export-light.svg';
import AirImportNotSelected from '../img/air-import-light.svg';
import AirExportNotSelected from '../img/air-export-light.svg';
import TruckingOthersNotSelected from '../img/other-shipment-light.svg';
import FreightReceiptNotSelected from '../img/freight-receipt-light.svg';
import utilitiesIcon from '../img/util-light.svg';
import ReportManagerNotSelected from '../img/op-manager-report-light.svg';
import RunnerIcon from '../img/runner.svg';
import ExitIcon from '../img/exit.svg';

import OceanImportNotSelectedSkyBlue from '../img/ocean-import-dark.svg';
import OceanExportNotSelectedSkyBlue from '../img/ocean-export-dark.svg';
import AirImportNotSelectedSkyBlue from '../img/air-import-dark.svg';
import AirExportNotSelectedSkyBlue from '../img/air-export-dark.svg';
import TruckingOthersNotSelectedSkyBlue from '../img/other-shipment-dark.svg';
import FreightReceiptNotSelectedSkyBlue from '../img/freight-receipt-dark.svg';
import WarehousingNotSelectedSkyBlue from '../img/warehouse-dark.svg';
import ReportManagerNotSelectedSkyBlue from '../img/op-manager-report-dark.svg';
import AccountingNotSelectedSkyBlue from '../img/accounting-dark.svg';
import utilitiesIconSkyBlue from '../img/util-dark.svg';
import BillingsNotSelectedSkyBlue from '../img/billings-dark-gnb.svg';
import BillingsNotSelected from '../img/billings-light-gnb.svg';
import myjobNotSelected from '../img/my-task-light.svg';
import myjobNotSelectedSkyBlue from '../img/my-task-dark.svg';
import aicenterNotSelected from '../img/ai-center-light.svg';
import aicenterNotSelectedSkyBlue from '../img/ai-center-dark.svg';

import taskReminderIcon from '../img/pin_red.svg';
import _ from 'lodash';
import TextBoxUncontrolled from '../ui/TextBoxUncontrolled';
import { getJobNameByTbName, getOpTypeConstant, JobNames } from '../framework.core/JobNames';
import useExternalScreenFilter from '../hooks/useExternalScreenFilter';
import { useHistory } from 'react-router';
import { SearchModelBase } from '../fms.data/models/SearchModelBase';
import { moveJobToOperation } from '../features/jobMenuSlice';
import { moveScreenToOperation, moveScreenToTop } from '../features/screenStackSlice';
import { NavigationType, openNewPage as NavOpenNewPage } from '../util/navigationHelpers';
import useJobMenus from '../hooks/useJobMenus';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import businessIntelligenceNotSelected from '../img/bi.svg';
import businessIntelligenceNotSelectedSkyBlue from '../img/bi_D.svg';

import amsNotSelected from '../img/ams-aci-light.svg';
import amsNotSelectedSkyBlue from '../img/ams-aci-dark.svg';
import aesNotSelected from '../img/aes-light.svg';
import aesNotSelectedSkyBlue from '../img/aes-dark.svg';
import isfNotSelected from '../img/isf-light.svg';
import isfNotSelectedSkyBlue from '../img/isf-dark.svg';
import { SecType } from '../fms.enum';
import {getReferenceFilesMenus}   from '../components/referenceFiles/ReferenceFiles';
import fastStorage from '../fastStorage';

const createMenuItem = (
  text: string,
  menuOp: string,
  icon: string,
  darkModeIcon: string,
  //hoverIcon: string,
  link: string,
  name: string,
  disable:boolean,
  disableIcon?: string,
): IfmsConfigMenuItem => ({
  text,
  menuOp,
  level: 0,
  icon: !_.isEmpty(icon) ? <img src={icon} style={getIconStyle(text)} alt="" /> : '',
  darkModeIcon: !_.isEmpty(darkModeIcon) ? <img src={darkModeIcon} style={getIconStyle(text)} alt="" /> : '',
  disableIcon: !_.isEmpty(disableIcon) ? <img src={disableIcon} style={getIconStyle(text)} alt="" /> : '',
  //hoverIcon: <img src={hoverIcon} style={getIconStyle(text)} alt="" />,
  isSelected: (o: string) => o === text,
  link,
  changeOperation: text,
  customId: text,
  changeSideMenu: text,
  name,
  disable,
});

const getIconStyle = (text: string): { height: number; width: number; } => {
  const defaultStyle: { height: number; width: number; } = { height: 14, width: 14 };
  const specialStyles: { [key: string]: { height: number; width: number; } } = {
    'Ocean Import': { height: 16, width: 16 },
    'Ocean Export': { height: 16, width: 16 },
    'Air Import': { height: 16, width: 16 },
    'Air Export': { height: 16, width: 16 },
    'Other Shipment': { height: 16, width: 16 },
    'Freight Receipt': { height: 16, width: 16 },
    'Warehouse': { height: 16, width: 16 },
    'Accounting': { height: 16, width: 16 },
    'OP Manager Report': { height: 16, width: 16 },
    'Billings': { height: 16, width: 16 },
    'Util': { height: 16, width: 16 },
    'Customer List': { height: 16, width: 16 },
    'Reference Files': { height: 16, width: 16 },
    'Container Tracking': { height: 16, width: 16 },
    'eSupport': { height: 16, width: 16 },
    'Settings': { height: 16, width: 16 },
    //'My CFS': { height: 20, width: 17 },
    //'Brokerage Trucking': { height: 20, width: 17 },
    'My Task': { height: 16, width: 16 },
    'In-bond': { height: 16, width: 16 },
    // 'Business Intelligence': { height: 20, width: 15 },
    'AMS/ACI': { height: 16, width: 16 },
    'AES': { height: 16, width: 16 },
    'ISF': { height: 16, width: 16 },
    'AI Center': {height: 16, width: 16},
  };
  return specialStyles[text] || defaultStyle;
};

const OceanImportMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Ocean Import',
    constants.operations.oceanImport,
    OceanImportNotSelected,
    OceanImportNotSelectedSkyBlue,
    //OceanImportHover,
    '/common/joblistview/mbl/oceanImport',
    'op-oceanImport',
    false
  ),
];

const OceanExportMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Ocean Export',
    constants.operations.oceanExport,
    OceanExportNotSelected,
    OceanExportNotSelectedSkyBlue,
    //OceanExportHover,
    '/common/joblistview/oeHbl/oceanExport',
    'opmenu-oceanExport',
    false
  ),
];

const AirImportMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Air Import',
    constants.operations.airImport,
    AirImportNotSelected,
    AirImportNotSelectedSkyBlue,
    //AirImportHover,
    '/common/joblistview/aiMawb/airImport',
    'opmenu-airImport',
    false
  ),
];

const AirExportMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Air Export',
    constants.operations.airExport,
    AirExportNotSelected,
    AirExportNotSelectedSkyBlue,
    //AirExportHover,
    '/common/joblistview/aeMawb/airExport',
    'opmenu-airExport',
    false
  ),
];

const OtherShipmentMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Other Shipment',
    constants.operations.otherShipment,
    TruckingOthersNotSelected,
    TruckingOthersNotSelectedSkyBlue,
    //TruckingOthersHover,
    '/common/joblistview/otherShipment/otherShipment',
    'opmenu-otherShipment',
    false
  ),
];

const FreightReceiptMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Freight Receipt',
    constants.operations.whReceipt,
    FreightReceiptNotSelected,
    FreightReceiptNotSelectedSkyBlue,
    //FreightReceiptSelected,
    '/common/joblistview/whReceipt/whReceipt',
    'opmenu-whReceipt',
    false
  ),
];

const WarehousingMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Warehouse',    //Change name Warehousing -> Warehouse
    constants.operations.warehousing,
    WarehousingNotSelected,
    WarehousingNotSelectedSkyBlue,
    //WarehousingHover,
    '/common/joblistview/whReceiving/warehousing',
    'opmenu-warehousing',
    false
  ),
];

// const MyCFSMenu: Array<IfmsConfigMenuItem> = [
//   createMenuItem(
//     'My CFS',
//     '',
//     mycfsNotSelected,
//     mycfsIconNotSelectedSkyBlue,
//     //'',
//     '',
//     'opmenu-utilities',
//     false,
//     mycfsIconNotSelectedGray,
//   )
// ];

// const BrokerageTruckingMenu: Array<IfmsConfigMenuItem> = [
//   createMenuItem(
//     'Brokerage Trucking',
//     '',
//     brokerageTruckingNotSelected,
//     brokerageTruckingNotSelectedSkyBlue,
//     //'',
//     '',
//     '',
//     false,
//     brokerageTruckingNotSelectedGray,
//   )
// ];



const OPReportMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'OP Manager Report',
    constants.operations.opReport,
    ReportManagerNotSelected,
    ReportManagerNotSelectedSkyBlue,
    //ReportManagerHover,
    '/opReport/estProfit?docType=705&isManagerReport=true&opType=oceanImport',
    'opmenu-opReport',
    false
  )
];

const BillingsMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Billings',
    constants.operations.billings,
    BillingsNotSelected,
    BillingsNotSelectedSkyBlue,
    //BillingsHover,
    '/common/joblistview/invoice/accounting?parentOp=billings',
    'opmenu-billings',
    false
  ),
];

const AccountingMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Accounting',
    constants.operations.accounting,
    AccountingNotSelected,
    AccountingNotSelectedSkyBlue,
    //AccountingHover,
    '/accounting/acBankBalanceView',
    'opmenu-accounting',
    false
  )
];

const customerListMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Customer List',
    'Customer List',
    CustomerListNotSelectedIcon,
    CustomerListSkyBlue,
    //CustomerListSelectedIcon,
    '/common/joblistview/company/customer',
    'opmenu-customerList',
    false
  )
];

const referenceFilesMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Reference Files',
    'Reference Codes',
    ReferenceFilesNotSelectedIcon,
    ReferenceFilesNotSelectedIconSkyBlue,
    //ReferenceFilesHoverIcon,
    '/referenceFiles',
    'opmenu-referenceFiles',
    false
  )
];

const continerTrackingTxt = 'Container Tracking';
const ContainerTrackingItems: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    continerTrackingTxt,
    '',
    ContainerTrackingIcon,
    ContainerTrackIconSkyBlue,
    //ContainerTrackIconWhite,
    '',
    'opmenu-containerTracking',
    false
  )
];

const UtilMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Util',
    constants.operations.utility,
    utilitiesIcon,
    utilitiesIconSkyBlue,
    //utilitiesHoverIcon,
    '/common/joblistview/utCommunication/utility',
    'opmenu-utilities',
    false
  )
];

const SetupMenuItems: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Settings',
    'Settings',
    SettingsNotSelectedIcon,
    SettingsNotSelectedIconSkyBlue,
    //SettingsHoverIcon,
    '/settings',
    'opmenu-settings',
    false
  )
];

const InbondMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'In-bond',
    '',
    inbondMenuIconBlue,
    inbondMenuIconSkyBlue,
    //utilitiesHoverIcon,
    '',
    'opmenu-in-bond',
    false
  )
];

const supportMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'eSupport',
    '',
    supportIcon,
    supportIconSkyBlue,
    //supportHoverIcon,
    '',
    'opmenu-eSupport',
    false
  )
];

// const BusinessIntelligenceMenu: Array<IfmsConfigMenuItem> = [
//   createMenuItem(
//     'Business Intelligence',
//     'Business Intelligence',
//     businessIntelligenceNotSelected,
//     businessIntelligenceNotSelectedSkyBlue,
//     //'',
//     '/accounting/acBusinessIntelligence',
//     'opmenu-bisunessIntenlligence',
//     false,
//   )
// ];

const AMSMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'AMS/ACI',
    constants.operations.ams,
    amsNotSelected,
    amsNotSelectedSkyBlue,
    //utilitiesHoverIcon,
    '/common/joblistview/AMSM/ams',
    'opmenu-ams',
    false
  )
];

const AESMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'AES',
    constants.operations.aes,
    aesNotSelected,
    aesNotSelectedSkyBlue,
    //utilitiesHoverIcon,
    '/common/joblistview/AESL/aes',
    'opmenu-aes',
    false
  )
];

const ISFMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'ISF',
    constants.operations.isf,
    isfNotSelected,
    isfNotSelectedSkyBlue,
    //utilitiesHoverIcon,
    '/common/joblistview/ISFL/isf',
    'opmenu-isf',
    false
  )
];

const MyTaskMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'My Task',
    constants.operations.myTask,
    myjobNotSelected,
    myjobNotSelectedSkyBlue,
    '/common/joblistview/TASKL/myTask',
    'opmenu-myTask',
    false,
  )
];

// const memoListMenu: Array<IfmsConfigMenuItem> = [
//   {
//     text: 'Memo & Log List',
//     level: 0,
//     icon: <img src={MemoListsNotSelectedIcon} style={{width: '18px', height: '18px'}} alt= "" />,
//     hoverIcon: <img src={MemoListsNotSelectedIcon} style={{width: '18px', height: '18px', filter: 'invert(100%) sepia(100%) saturate(25%) hue-rotate(360deg) brightness(206%) contrast(205%)'}} alt= "" />,
//     link: '/memoList',
//     isSelected: (_,c) => c === '/memoList',
//     width: '110px',
//   }
// ];

const CntrMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'Container List',
    constants.operations.cntr,
    '',
    '',
    // utilitiesHoverIcon,
    '/common/joblistview/allContainer/cntr',
    'opmenu-cntr',
    false
  )
];

const AICenterMenu: Array<IfmsConfigMenuItem> = [
  createMenuItem(
    'AI Center',
    constants.operations.aiCenter,
    aicenterNotSelected,
    aicenterNotSelectedSkyBlue,
    '/common/joblistview/AICTR/aiCenter',
    'opmenu-aiCenter',
    false,
  )
];

type IfmsTopBarProps = {
  onMenuItemClicked: (menuItem: IfmsConfigMenuItem) => void,
  systemSettings: SystemSettings | null,
  user: User | null,
  homeMenu?: Array<IfmsConfigMenuItem> | null | undefined,
  selectedOperation: string,
  menus: IfmsConfigOperationMenu | null | undefined,
  currentUrl: string,
  openNewPage: (link: string) => void,
  logout: () => Promise<void>,
  isLicenseeList?: boolean,
};

let observer: MutationObserver | null = null;

const IfmsTopBar: React.FC<IfmsTopBarProps> = ({
  onMenuItemClicked,
  systemSettings,
  homeMenu,
  selectedOperation,
  menus,
  currentUrl,
  openNewPage,
  logout,
  user,
  isLicenseeList,
}) => {
  const dispatch = useAppDispatch();
  const [displayOperation, setDisplayOperation] = useState<string>(selectedOperation);
  let standaloneTitleChangeSubscription = useRef<ISubscriptionDefinition<any> | null>(null);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<UserButtonItem | null>(null);
  const [searchType, setSearchType] = useState<string>('BL');
  const [searchText, setSearchText] = useState<string>(''); 
  const [isHoverSearchInput, setIsHoverSearchInput] = useState(false);
  const [isFocusSearchInput, setIsFocusSearchInput] = useState(false);
  const versionCount = useRef<number>(1);   

  //const lastHomeClickedFrom = useRef<string>('');

  const appContext = useContext(ApplicationContext);
  let grents = appContext.securityGrants;
  const configMenu = _.cloneDeep(config.menus);
  //const sSetupSec = appContext.securityGrants?.find(x=>x.securityTaskCode === FmsSecTask.SystemSetup);
  const compSec = appContext.securityGrants?.find(x => x.securityTaskCode === FmsSecTask.CodeCompany);
  const myEventSec = appContext.securityGrants?.find(x => x.securityTaskCode === FmsSecTask.MyEvent);
  const businessIntelligenceSec = appContext.securityGrants?.find(x => x.securityTaskCode === FmsSecTask.BusinessIntelligence);
  const enableMyEvent = appContext.suntekSettings?.general?.enableMyEvent?? false;
  const myTaskSec = appContext.securityGrants?.find(x => x.securityTaskCode === FmsSecTask.TaskList);
  const homeUrls = ['/', '/home', '/home/home'];
  const useDarkMode = appContext.useDarkMode;
  const { getSingleOpenedScreenInAnyOperationStartingWithUrl } = useJobMenus();
  const {setFilterForScreenExternally} = useExternalScreenFilter();

  // const MyEventMenu: Array<IfmsConfigMenuItem> = [
  //   createMenuItem(
  //     'My Event',
  //     constants.operations.myEvent,
  //     myjobNotSelected,
  //     myjobNotSelectedSkyBlue,
  //     '/common/joblistview/MYEVT/myEvent',
  //     'opmenu-myEvent',
  //     !enableMyEvent,
  //     myjobNotSelectedGray,
  //   )
  // ];


  //const goToHomeIconVisible = homeUrls.includes(currentUrl) && !homeUrls.includes(lastHomeClickedFrom.current) && !_.isEmpty(lastHomeClickedFrom.current);
  useEffect(() => {
    // alignReportMenus();

    let dopr = (selectedOperation !== constants.operations.standalone /*|| selectedOperation !== constants.operations.myTask*/)
      ? selectedOperation
      : '';

    if (dopr !== displayOperation) {
      setDisplayOperation(dopr);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOperation]);

  useEffect(() => {
    initialize();

    return uninitialize;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function doLogout() {
    setSelectedPopupMenuItem(null);
    logout();
  }

  async function goToInbond() {
    var apiResult = await appContext.api.getInbondLink()

    if (apiResult && apiResult.success) {
      window.open('https://inbond.suntekscm.com/Account/AutoLoginInBondFms?args=' + apiResult.result);
    }
  }

  async function goToSupport() {
    var apiResult = await appContext.api.getSupportLink()

    if (apiResult && apiResult.success) {
      window.open('http://bbs.suntekscm.com/Login.aspx?loginInfo=' + apiResult.result);
    }
  }

  // async function goToAMS() {
  //   const isAmsEnable = appContext.suntekSettings?.compliance?.amsEnable;
  //   var apiResult = await appContext.api.getAmsLink();

  //   if (apiResult && apiResult.success) {
  //     if (isAmsEnable) {
  //       window.open('https://ams1.suntekscm.com/login_auto.aspx?' + apiResult.result);
  //     } else {
  //       window.open('https://ams1.suntekscm.com/login_2017.aspx');
  //     }
  //   }
  // }


  function subscribeChannels() {
    standaloneTitleChangeSubscription.current = postal.subscribe({
      channel: 'ifms',
      topic: 'ifms.standalone-title',
      callback: (title: string) => {
        setTimeout(() => {
          setDisplayOperation(title);
        }, 50);
      },
    });
  }

  function unsubscribeChannels() {
    if (standaloneTitleChangeSubscription.current) {
      postal.unsubscribe(standaloneTitleChangeSubscription.current);
    }
  }

  function initialize() {
    subscribeChannels();

    const targetNode = document.getElementById('ifms-top-bar');
    if (targetNode) {

      if (!observer) {
        const observerConfig = {
          attributes: true,
          childList: true,
          subtree: true,
        };

        observer = new MutationObserver(observe);
        observer.observe(targetNode, observerConfig);
      }

      /*if (!resizeObserver) {
        resizeObserver = new ResizeObserver(alignReportMenus);
        resizeObserver.observe(targetNode);
      }*/
    }
  }

  function uninitialize() {
    unsubscribeChannels();

    if (observer) {
      observer.disconnect();
      observer = null;
    }

    /*if (resizeObserver) {
      resizeObserver.disconnect();
    }*/
  }

  function observe() {
    const topMenus = document.querySelectorAll('[data-submenuselected]');
    if (topMenus) {
      for (let i = 0; i < topMenus.length; i++) {
        const el = topMenus[i];
        if (el instanceof HTMLElement) {
          const selectedAttr = el.dataset.submenuselected;
          if (selectedAttr === 'true') {
            if (!el.classList.contains('rc-menu-submenu-selected')) {
              el.classList.add('rc-menu-submenu-selected');
            }
          } else {
            if (el.classList.contains('rc-menu-submenu-selected')) {
              el.classList.remove('rc-menu-submenu-selected');
            }
          }
        }
      }
    }
  }

  // const hasJob = !!menus && !!menus.job && menus.job.length > 0;
  // const hasReport = !!menus && !!menus.report && menus.report.length > 0;
  // const hasPreReport = !!menus && !!menus.preReport && menus.preReport.length > 0;
  // const hasOperationReport = !!menus && !!menus.operationReport && menus.operationReport.length > 0;

  // let userEmail = '';
  // if (user) {
  //   if (user.department) {
  //     userEmail = `${user.email} - ${user.departmentName}`;
  //   } else {
  //     userEmail = user.email ?? '';
  //   }
  // }

  function goToHome(callByLogo: boolean) {
    // if (goToHomeIconVisible) {
    //   if (!callByLogo) {
    //     let nextUrl = lastHomeClickedFrom.current;
    //     lastHomeClickedFrom.current = '';
    //     openNewPage(nextUrl);
    //   }
    // } else {
    // lastHomeClickedFrom.current = currentUrl;
    dispatch(changeOperation('Home'));
    openNewPage('/home/home');
    // }
  }

  // function getDbNameWithSuntekId() {
  //   //<pt231216: [userid-login]
  //   //const authService = new AuthService();
  //   // const licProduct:LicProduct = authService.getUserLicProduct();

  //   // return `${licProduct.database_DBName??''} (${licProduct.licID})`;
  //   return user === null ? "" : <p>{user.defaultDatabase?.toUpperCase()??''}<br/>({user.suntekId})</p>;
  //   //pt231216>
  // }

  /*
    const onLinkClick = (link: string) => {
      setSelectedPopupMenuItem(null);
      
      if (link.includes('http'))
        window.open(link);
      else
        openNewPage(link)
    }
  
    function changeButton(_button: ButtonItem) {
      const newButton: IfmsConfigMenuItem =
      {
        text: _button.label,
        level: 0,
        metadata: _button.metadata,
        link: _button.link,
        changeOperation:'Utility',
        changeSideMenu:'Utility'
      }
      return newButton;
    }
  
    async function checkFileServer() {
      const apiResult2: ApiResult<InsertResultsWithData> = await appContext.api.checkfileserver();
      if (apiResult2 && apiResult2.success)
        await showGlobalOkDialog(<p>File Server is working!</p>);
      else
        await showGlobalOkDialog(<p>File Server is not working!</p>);
    }
  
    async function setMilestoneOption(jobName:string){
      if(jobName === 'OIH'){
        if(hasOpenedScreenStartingWithUrl('/common/joblistview/hbl/oceanImport')){
          await showGlobalOkDialog(<p>Please close HBL List (OI)</p>);
          return;
        }
        appContext.setSystemSettings({
          ...appContext.systemSettings,
          showMilestoneInOihList:!appContext.systemSettings?.showMilestoneInOihList,
        });
      }
      else{
        if(hasOpenedScreenStartingWithUrl('/common/joblistview/aiHawb/airImport')){
          await showGlobalOkDialog(<p>Please close HAWB List (AI)</p>);
          return;
        }
        appContext.setSystemSettings({
          ...appContext.systemSettings,
          showMilestoneInAihList:!appContext.systemSettings?.showMilestoneInAihList,
        });
      }
    }
  
    async function openESupportPage(){
      const openURL:string = await appContext.api.getESupportURL(fmsGlobal.AcmeID)
      window.open(openURL);
    }
    */

  // async function searchData(searchType: string, searchText: string){
  async function searchData(searchText: string){
    // const apiResult = await appContext.api.getSearchAllTable(searchType, searchText);
    const apiResult = await appContext.api.getSearchAllTable(searchText);
    if(apiResult && apiResult.success && apiResult.result){
      const searchType = apiResult.result.searchType;
      const tbName = apiResult.result.tbName;
      const tbId = apiResult.result.tbId;
      const showList = apiResult.result.showList;
      const hdType = apiResult.result.hdType;
      const id = apiResult.result.id;
      const refNo = apiResult.result.refNo;
      let detailUrl = '';
      let jobName = getJobNameByTbName(tbName);

      if(searchType === 'ACCT'){
        switch(hdType){
          case "T_INVOHD":
            if(tbName ==="T_WSHIPHD" ||tbName ==="T_WRECEIVE" ){
              if(getSecBySecTask(appContext, FmsSecTask.AcctInvoiceList, SecType.Read))
                jobName = JobNames.Invoice;
              else
                jobName = JobNames.WHInvoice;
            }else if(tbName === "")
              jobName = JobNames.GInvo;
             else if (tbName === "T_STORAGE")
               jobName = JobNames.WHStorageInv;
             else 
              jobName = JobNames.Invoice;

            // if(tbName) jobName = JobNames.Invoice;
            // else jobName = JobNames.GInvo;
            break;
          case "T_APHD":
            if(tbName ==="T_WSHIPHD" ||tbName ==="T_WRECEIVE" ){
              if(getSecBySecTask(appContext, FmsSecTask.AcctBillList, SecType.Read))
                jobName = JobNames.Bill;
              else
                jobName = JobNames.WHBill;
            }else if(tbName === "")
              jobName = JobNames.GBill;
            else
              jobName = JobNames.Bill;

            // if(tbName) jobName = JobNames.Bill;
            // else jobName = JobNames.GBill;
            break;
          case "T_CRDBHD":
            if (tbName === "T_WSHIPHD" || tbName === "T_WRECEIVE") {
              if (getSecBySecTask(appContext, FmsSecTask.AcctCrDbList, SecType.Read))
                jobName = JobNames.CrDb;
              else
                jobName = JobNames.WHCrDb;
            }
            else
              jobName = JobNames.CrDb;
            break;
        }
      }
      if(showList){
          switchToList(jobName, searchText, searchType, showList, id, refNo);
      }else{
        detailUrl = getDetailUrlByJobName(jobName, tbId, tbName, id);

        let opType = getOpTypeConstant(jobName);

        const lastScreenQuery = getSingleOpenedScreenInAnyOperationStartingWithUrl(detailUrl);
        if (lastScreenQuery && lastScreenQuery.item) {
          // opertaion location update
          if (!opType) {
            opType = lastScreenQuery.operation;
          }

          // screen open
          dispatch(moveScreenToTop({
            url: detailUrl,
            operation: opType,
          }));
    
          // open page.
          NavOpenNewPage(history, detailUrl, NavigationType.jobMenuSwitch, 
            lastScreenQuery.item.metadata, 
            opType??lastScreenQuery.item.afterScreenUrl);
          return;
        }
        
        openNewPage(detailUrl);
      }
    }else{
      setSearchText("No Found Data");
      setTimeout(() => {
        const focusElement = document.getElementById("ifms-search-text") as HTMLInputElement;
        if (focusElement) {
          focusElement.focus();
          focusElement.select();
        }
      }, 100);
    }
  }

  function getDetailUrlByJobName(jobName: string, tbId: number, tbName: string = '', id: number = 0){
    switch(jobName){
      case JobNames.OIMbl:                    return `/oceanImport/mbl/view/${tbId}`;
      case JobNames.OIHbl:                    return `/oceanImport/hbl/view/${tbId}`;
      case JobNames.OEMbl:                    return `/oceanExport/mbl/view/${tbId}`;
      case JobNames.OEHbl:                    return `/oceanExport/hbl/view/${tbId}`;

      case JobNames.AIMbl:                    return `/airImport/mawb/view/${tbId}`;
      case JobNames.AIHbl:                    return `/airImport/hawb/view/${tbId}`;
      case JobNames.AEMbl:                    return `/airExport/mawb/view/${tbId}`;
      case JobNames.AEHbl:                    return `/airExport/hawb/view/${tbId}`;
      case JobNames.OtherOP:                  return `/otherShipment/otherShipment/view/${tbId}`;
      case JobNames.WHRcv:                    return `/warehousing/receiving/view/${tbId}`;
      case JobNames.WHShip:                   return `/warehousing/shipping/view/${tbId}`;
     
      case JobNames.Invoice:
      case JobNames.WHInvoice:                return `/accounting/invoice/view/${getJobNameByTbName(tbName)}/${tbId}/${id}`;
      case JobNames.GInvo:                    return `/accounting/acGeneralInvoice/view/${id}`;
      case JobNames.CrDb:  
      case JobNames.WHCrDb:                   return `/accounting/crdb/view/${getJobNameByTbName(tbName)}/${tbId}/${id}`;
      case JobNames.Bill:       
      case JobNames.WHBill:                    return `/accounting/bill/view/${getJobNameByTbName(tbName)}/${tbId}/${id}`;
      case JobNames.GBill:                     return `/accounting/acGeneralBill/view/${id}`;
      case JobNames.WHStorageInv:             return `/warehousing/storageInvoice/view/${id}`;
      
      default : return '';
    }
  }

  
  const history = useHistory();

  function switchToList(jobName: JobNames, searchText: string, searchType: string, showList: boolean, id: number, refNo: string) {
    let blType = '';
    let columnLabel = '';
    let columnId = '';
    let text = '';
    let columnIdEx: string | null = null;
    let textEx: string | null = null;
    let parentOp = false;
    let expressSearchCol = 'createdAt';
    let orderBy = '';
    switch (jobName) {
      case JobNames.OIMbl:
        blType = 'mbl';
        orderBy = 'u2Date';
        if (searchType === "CNTR") {
          columnLabel = 'Container'
          columnId = 'containerNo'
        } else if (searchType === "REF") {
          columnLabel = 'Ref. #'
          columnId = 'refNo'
        } else {
          columnLabel = 'MBL'
          columnId = 'mblNo'
        }
        text = searchText;
        break;
      case JobNames.OIHbl:
        blType = 'hbl';
        orderBy = 'u2Date';
        if (searchType === "CNTR") {
          if (id > 0) {
            columnId = showList ? 'oiMblId' : 'cntrNo';
            columnLabel = showList ? 'Ref. #' : 'Container';
            columnIdEx = showList ? 'refNo' : null;
            text = showList ? id.toString() : searchText;
            textEx = showList ? refNo : null;
          } else {
            columnId = 'cntrNo';
            columnLabel = 'Container';
            text = searchText;
          }
        } else if (searchType === "REF") {
          columnLabel = 'Ref. #'
          columnId = 'refNo'
          text = searchText;
        } else {
          columnId = 'hblNo';
          columnLabel = 'HBL';
          text = searchText;
        }
        break;
      case JobNames.OEMbl:
        blType = 'oeMbl';
        orderBy = 'u2Date';
        if (searchType === "CNTR") {
          columnLabel = 'Container'
          columnId = 'containerNo'
        } else if (searchType === "REF") {
          columnLabel = 'Ref. #'
          columnId = 'refNo'
        } else {
          columnLabel = 'MBL'
          columnId = 'mblNo'
        }
        text = searchText;
        break;
      case JobNames.OEHbl:
        blType = 'oeHbl';
        orderBy = 'u2Date';
        if (searchType === "CNTR") {
          // columnId = showList ? 'oeMblId' : 'containerNo';
          // columnLabel = showList ? 'Ref. #' : 'Container';
          // columnIdEx = showList ? 'refNo' : null;
          // text = showList ? id.toString() : searchText;
          // textEx = showList ? refNo : null;
          if (id > 0) {
            columnId = showList ? 'oeMblId' : 'containerNo';
            columnLabel = showList ? 'Ref. #' : 'Container';
            columnIdEx = showList ? 'refNo' : null;
            text = showList ? id.toString() : searchText;
            textEx = showList ? refNo : null;
          } else {
            columnId = 'containerNo';
            columnLabel = 'Container';
            text = searchText;
          }
        } else if (searchType === "REF") {
          columnLabel = 'Ref. #'
          columnId = 'refNo'
          text = searchText;
        } else {
          columnId = 'hblNo';
          columnLabel = 'HBL';
          text = searchText;
        }
        break;
      case JobNames.AIMbl:
        blType = 'aiMawb';
        orderBy = 'u2Date';
        if (searchType === "REF") {
          columnLabel = 'Ref. #'
          columnId = 'refNo'
        } else {
          columnLabel = 'MAWB'
          columnId = 'mawbNo'
        }
        text = searchText;
        break;
      case JobNames.AIHbl:
        blType = 'aiHawb';
        orderBy = 'u2Date';
        if (searchType === "REF") {
          columnLabel = 'Ref. #'
          columnId = 'refNo'
        } else {
          columnLabel = 'HAWB';
          columnId = 'hawbNo';
        }
        text = searchText;
        break;
      case JobNames.AEMbl:
        blType = 'aeMawb';
        orderBy = 'u2Date';
        if (searchType === "REF") {
          columnLabel = 'Ref. #'
          columnId = 'refNo'
        } else {
          columnLabel = 'MAWB'
          columnId = 'mawbNo'
        }
        text = searchText;
        break;
      case JobNames.AEHbl:
        orderBy = 'u2Date';
        blType = 'aeHawb';
        if (searchType === "REF") {
          columnLabel = 'Ref. #'
          columnId = 'refNo'
        } else {
          columnLabel = 'HAWB';
          columnId = 'hawbNo';
        }
        expressSearchCol = 'u1Date';
        text = searchText;
        break;
      case JobNames.OtherOP:
        blType = 'otherShipment';
        orderBy = 'u2Date';
        if (searchType === "CNTR") {
          columnLabel = 'Container';
          columnId = 'container';
        } else if (searchType === "REF") {
          columnLabel = 'Ref.';
          columnId = 'refNo';
        }
        else {
          columnLabel = 'HBL / HAWB';
          columnId = 'hblNo';
        }
        text = searchText;
        break;
      case JobNames.WHRcv:
        orderBy = 'u2Date';
        blType = 'whReceiving';
        columnLabel = 'Receiving ID';
        columnId = 'receiveNo';
        text = searchText;
        break;
      case JobNames.WHShip:
        orderBy = 'u2Date';
        blType = 'whShipping';
        columnLabel = 'Shipping ID';
        columnId = 'shipNo';
        text = searchText;
        break;
      case JobNames.Invoice:
        orderBy = 'u2Date';
        blType = 'invoice';
        columnLabel = 'Invoice #';
        columnId = 'invoiceNo';
        parentOp = true;
        text = searchText;
        break;
      case JobNames.GInvo:
        orderBy = 'u2Date';
        blType = 'acGeneralInvoice';
        columnLabel = 'G.Invoice #';
        columnId = 'invoiceNo';
        text = searchText;
        break;
      case JobNames.WHStorageInv:
        orderBy = 'u2Date';
        blType = 'whStorageInvoice';
        columnLabel = 'Invoice #';
        columnId = 'invoiceNo';
        text = searchText;
        break;
      case JobNames.WHInvoice:
        orderBy = 'u2Date';
        blType = 'invoice';
        columnLabel = 'Invoice #';
        columnId = 'invoiceNo';
        text = searchText;
        break;
      case JobNames.Bill:
        orderBy = 'updatedDate';
        blType = 'bill';
        columnLabel = 'Bill #';
        columnId = 'billNo';
        expressSearchCol = 'createdDate';
        parentOp = true;
        text = searchText;
        break;
      case JobNames.GBill:
        orderBy = 'updatedDate';
        blType = 'acGeneralBill';
        columnLabel = 'G.Bill #';
        columnId = 'billNo';
        expressSearchCol = 'createdDate';
        text = searchText;
        break;
      case JobNames.WHBill:
        orderBy = 'updatedDate';
        blType = 'bill';
        columnLabel = 'Bill #';
        columnId = 'billNo';
        text = searchText;
        break;
      case JobNames.CrDb:
        blType = 'crdb';
        columnLabel = 'Crdb #';
        columnId = 'crDbNo';
        parentOp = true;
        expressSearchCol = 'u1Date';
        text = searchText;
        orderBy = 'u2Date';
        break;
      case JobNames.WHCrDb:
        blType = 'crdb';
        columnLabel = 'Crdb #';
        columnId = 'crDbNo';
        text = searchText;
        orderBy = 'u2Date';
        break;
      default:
        break;
    }
    const opType = getOpTypeConstant(jobName);

    let model = new SearchModelBase();
    model.isExpressSearch = true;
    model.version = versionCount.current;  // Update version
    model.expressSearchCol = expressSearchCol;

    const link =`/common/joblistview/${blType}/${opType ? opType : 'accounting'}${parentOp ? '?parentOp=accounting': ''}`;
    setFilterForScreenExternally(
      link,
      columnId,
      columnLabel,
      text.toString(),
      orderBy,
      false,
      true,
      model,
      columnIdEx,
      textEx,
      true,
      true
    );

    versionCount.current += 1;

    openNewPage(link);
  }


  const OperationMenus: Array<IfmsConfigMenuItem> = [
    ...OceanImportMenu,
    ...OceanExportMenu,
    ...AirImportMenu,
    ...AirExportMenu,
    ...OtherShipmentMenu,
    ...FreightReceiptMenu,
    ...WarehousingMenu,
    //...MyCFSMenu,
    //...BrokerageTruckingMenu,
    ...OPReportMenu,
    ...BillingsMenu,
    ...AccountingMenu,
    ...customerListMenu,
    ...referenceFilesMenu,
    ...ContainerTrackingItems,
    ...SetupMenuItems,
    ...UtilMenu,
    ...InbondMenu,
    ...supportMenu,
    ...CntrMenu
  ];


  //<Top Bar에서 해당 Operation에 관련 없는 Security만 활성화되어있을때 Top Bar에서 해당 Operation 메뉴를 숨기기 위해 추가
  const securityCheckMenuOps = [
    constants.operations.oceanImport,
    constants.operations.oceanExport,
    constants.operations.airImport,
    constants.operations.airExport,
    constants.operations.otherShipment,
    constants.operations.utility,
    constants.operations.accounting
  ]
  //end>

  //<Reference Files Security 권한 여부 체크 
  function filteredReferenceFilesMenu(){
    const refMenus = getReferenceFilesMenus();
    let job = MenuFilterGrents(refMenus.job, grents, appContext);
    if(job.length > 0) return true;

    else return false;
  }

  const isShowMenu = filteredReferenceFilesMenu();
  //end>

  function getMenuItemLink(menuItems: IfmsConfigMenuItem[], menuOp: string) {

    if (!securityCheckMenuOps.includes(menuOp) && menuOp !== constants.operations.ams) {
      return menuItems[0]?.link;
    }

    const target = menuItems.find(x => x.secTaskGroup === menuOp);
    if (!target) return menuItems[0]?.link;
    if (target.link) {
      return target.link;
    }
    
    //security 권한이 ex) OI > Report > Arrival Notice Log 에 있는 경우 링크 연결해주기 위해 추가 
    if (target.items?.length) {
      const firstLinkedItem = target.items.find(item => item.link);
      if (firstLinkedItem) {
        return firstLinkedItem.link;
      }
    }

    return menuItems[0]?.link;
  }

  function hasGrantedMenu(items: IfmsConfigMenuItem[] | null | undefined, menuOp?: string): boolean {
    return (items ?? []).some(x => {
      if (menuOp !== undefined && x.secTaskGroup !== menuOp) return false;
      return !!x.fmsSecTask || hasGrantedMenu(x.items);
    });
  }

  // for tabbar menu link setting.
  const filterMenuItems = (menuItems: IfmsConfigMenuItem[]) => {
    return _.cloneDeep(menuItems).filter(op => {
      const opSide = _.cloneDeep(configMenu.find(cm => cm.operation === op.menuOp));
      if (!opSide) return false;

      opSide.job = MenuFilterGrents(opSide.job, grents, appContext);

      const menuOp = op.menuOp ?? '';
      if (!hasGrantedMenu(opSide.job, securityCheckMenuOps.includes(menuOp) ? menuOp : undefined)) {
        return false;
      }

      if (opSide.job.find(x => x.link === op.link)) {
        return true;
      }

      for (const job of opSide.job) {
        if (job.items?.find(x => x.link === op.link)) {
          return true;
        }
      }

      op.link = getMenuItemLink(opSide.job, menuOp);
      if (menuOp === constants.operations.ams) {
        fastStorage['security-ams-menu-link'] = op.link ?? null;
      }
      return true;
    });
  };

  const filteredOceanImportMenu = filterMenuItems(OceanImportMenu);
  const filteredOceanExportMenu = filterMenuItems(OceanExportMenu);
  const filteredAirImportMenu = filterMenuItems(AirImportMenu);
  const filteredAirExportMenu = filterMenuItems(AirExportMenu);
  const filteredOtherShipmentMenu = filterMenuItems(OtherShipmentMenu);
  const filteredFreightReceiptMenu = filterMenuItems(FreightReceiptMenu);
  const filteredWarehousingMenu = filterMenuItems(WarehousingMenu);
  const filteredOPReportMenu = filterMenuItems(OPReportMenu);
  const filteredBillingsMenu = filterMenuItems(BillingsMenu);
  // Client Setup > Accounting Start Menu 에서 선택한 화면으로 시작 (권한이 없으면 filterMenuItems 에서 권한 있는 메뉴로 대체)
  const acctStartMenu = appContext.systemSettings?.acctStartMenu;
  const filteredAccountingMenu = filterMenuItems(AccountingMenu.map(x => ({ ...x, link: acctStartMenu || x.link })));
  const filteredUtilMenu = filterMenuItems(UtilMenu);
  const filteredAMSMenu = filterMenuItems(AMSMenu);
  const filteredISFMenu = filterMenuItems(ISFMenu);
  const filteredAESMenu = filterMenuItems(AESMenu);

  return (
    <>
      <div id={!useDarkMode ? "ifms-app-common-bar" : "ifms-app-common-bar-darkmode"}>
        <div id='ifms-main-logo'>
          <a style={{ cursor: homeUrls.includes(currentUrl) ? 'default' : 'pointer' }} onClick={() => goToHome(true)}>
            <img src={!useDarkMode ? ifmsLogo : ifmsLogoWhite} alt="Suntek Systems - iFMS" width="90px" />
            </a>
        </div>
        <div className={'top-bar-menu-style'}>
          <div style={{ display: 'flex', fontSize: '13px', gap: '20px'}}>
            <div style={{ width: '133px' }}>
              <DashboardMenu items={filteredOceanImportMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '106px' }}>
              <DashboardMenu items={filteredOceanExportMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '88px' }}>
              <DashboardMenu items={filteredAirImportMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '102px' }}>
              <DashboardMenu items={filteredAirExportMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '119px' }}>
              <DashboardMenu items={filteredOtherShipmentMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '116px' }}>
              <DashboardMenu items={filteredFreightReceiptMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '91px' }}>
              <DashboardMenu items={filteredWarehousingMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '76px' }}>
                <DashboardMenu items={filteredAMSMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '69px'}}>
              <DashboardMenu items={filteredISFMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '74px' }}>
              <DashboardMenu items={filteredAESMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '69px' }}>
              <DashboardMenu items={InbondMenu} onMenuItemSelected={goToInbond} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
          </div>

          <div style={{ display: 'flex', fontSize: '12px', gap: '20px' }}>
            <div style={{ width: '133px' }}>
              <DashboardMenu items={filteredOPReportMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '106px' }}>
              <DashboardMenu items={filteredBillingsMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '88px' }}>
              <DashboardMenu items={filteredAccountingMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '102px' }}>
              {(user?.isSuntekAdmin || compSec?.grantRead) &&
                <DashboardMenu items={customerListMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
              }
            </div>
            <div style={{ width: '119px' }}>
              {(user?.isSuntekAdmin || isShowMenu) &&
                <DashboardMenu items={referenceFilesMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />}
            </div>

            <div style={{ width: '116px' }}>
              <DashboardMenu items={filteredUtilMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            {/* <div style={{ width: '160px' }}>
              {(user?.isSuntekAdmin || businessIntelligenceSec?.grantRead) &&
                <DashboardMenu items={BusinessIntelligenceMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />}
            </div> */}
            <div style={{ width: '91px', display:'flex' }}>
              {(user?.isSuntekAdmin || myTaskSec?.grantRead) && <DashboardMenu items={MyTaskMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl}  /> }
              {/*{["R", "Y", "G"].includes(appContext.systemSettings?.reminderStatus ?? '') && <img style={{ marginLeft: '5px', marginTop:'10px', width:'11px', height:'11px' }} src={taskReminderIcon}></img>}*/}
            </div>
            <div style={{ width: '76px' }}>
               <DashboardMenu items={AICenterMenu} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '69px' }}>
               <DashboardMenu items={SetupMenuItems} onMenuItemSelected={onMenuItemClicked} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '74px' }}>
              <DashboardMenu items={supportMenu} onMenuItemSelected={goToSupport} selectedOperation={selectedOperation} currentUrl={currentUrl} />
            </div>
            <div style={{ width: '68.63px' }}>
            </div>
          </div>
        </div>

        <div style={{ minWidth: '235px', width: '285px', display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{ width: '235px', display: 'flex' }}>
            <TextBoxUncontrolled
              id={"ifms-search-text"}
              noborder
              focusable={false}
              style={{
                display: 'flex', paddingLeft: '15px', height: '30px', borderRadius: '13px', background: isHoverSearchInput ? '#ACFFEF' : 'white',
                boxShadow: appContext.useDarkMode ? '0px 0px 2px 2px #7F7F7F' : '0px 0px 2px 2px #7DB1BF',
                border: appContext.useDarkMode ? '2px solid #C3C3C3' : '2px solid #0279A4'
              }}
              maxLength={25}
              initialValue={searchText}
              onMouseOver={() => setIsHoverSearchInput(true)}
              onMouseLeave={() => setIsHoverSearchInput(false)}
              onEnter={async () => await searchData(searchText)}
              onChange={(e: any) => { setSearchText(e.target.value) }}
              onFocus={() => setIsFocusSearchInput(true)}
              onBlur={() => setIsFocusSearchInput(false)}
              placeholder={isFocusSearchInput ? '' : 'Up to Recent 3 Month Data'}
              data-tooltipposition = {'expresssearch'}
              tooltipText={'Enter Ref. #, B/L #, CNTR #, Billing #'}
            />
            <FontAwesomeIcon
              color='#a1a1a1'
              onClick={async () => await searchData(searchText)}
              icon={faSearch} size={'1x'}
              style={{ position: 'relative', cursor: 'pointer', top: '8px', right: '28px' }}
            />
          </div>
        </div>

        <div style={{ marginLeft: 'auto' }}>
          <UserButton
            items={[
              {
                label: 'Logout',
                icon: <img src={RunnerIcon} style={{ width: '16px', height: '16px' }} alt="" />,
                icon2: <img src={ExitIcon} style={{ width: '20px', height: '20px' }} alt="" />,
                separator: false
              }
            ]}
            onItemSelected={(event) => setSelectedPopupMenuItem(event)}
            user={user}
          >
          </UserButton>
          {!!selectedPopupMenuItem && selectedPopupMenuItem.label === 'Logout' ? doLogout() : null}
        </div>
        {systemSettings?.enableBranch && user?.branch &&
          <span style={{ fontSize: '11px', marginLeft: '5px', color: useDarkMode ? 'white' : 'black' }}>{user?.branch ?? ''}</span>
        }
      </div>
    </>
  );
};


export default IfmsTopBar;
